import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function clientexpectation() {
  return (
    <section className="client_expectation p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/teemates/dark_mode.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={611}
              height={570}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>2. Dark Mode</h2>
            <p>
              Considering the average screen times on social media apps, our
              designers wanted to create app experiences that would not cause
              eye strains with prolonged usage. The app, depending on the
              smartphone settings, can adjust to current light settings and
              reduce battery consumption during specific hours.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default clientexpectation;
